jQuery  (
        function()
            {           
            $(document).on  (
                'keydown',
                '.ctrl-s',                                                    
                function(e)
                    {                                                                                                   
                    //CTRL + S keydown combo
                    if(e.ctrlKey && e.keyCode == 83)
                        {                                  
                        e.preventDefault();                                                                 
                        $(e.currentTarget).submit();                                                                
                        }
                    }
                );
            }
        );